// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-placeholder-container[data-v-137d6a68] {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  min-width: 120px;
}
.medium-message-placeholder[data-v-137d6a68] {
  height: 20px;
  background-color: lightgrey;
  margin-bottom: 10px;
  border-radius: 8px;
}
[data-v-137d6a68] .story-builder-container.col {
  padding-top: 34px !important;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/dynamic-component-editor/standard-pages/edit-article-page/elements/ArticleEditor.vue","webpack://./ArticleEditor.vue"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;ACDF;ADIA;EACE,YAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;ACDF;ADIA;EACE,4BAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.message-placeholder-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 8px;\n  min-width: 120px;\n}\n\n.medium-message-placeholder {\n  height: 20px;\n  background-color: lightgrey;\n  margin-bottom: 10px;\n  border-radius: 8px;\n}\n\n:deep(.story-builder-container.col) {\n  padding-top: 34px !important;\n}\n",".message-placeholder-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 8px;\n  min-width: 120px;\n}\n\n.medium-message-placeholder {\n  height: 20px;\n  background-color: lightgrey;\n  margin-bottom: 10px;\n  border-radius: 8px;\n}\n\n:deep(.story-builder-container.col) {\n  padding-top: 34px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
